import { StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  card: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    paddingTop: 16,
    paddingBottom: 12,
    borderRadius: 6.3,
    shadowColor: Colors.linegrey,
    shadowOpacity: 1,
    shadowOffset: { height: 2 },
    shadowRadius: 8,
    elevation: 4,
    paddingHorizontal: 17.7,
    marginRight: 15.3,
    marginLeft: 16.7,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  }),
  mainTitle: {
    fontSize: 16.7,
  },
});
